import { Callback } from '@deqo/foundation';


const state = {
    current: null as FrameData,
    frames: [] as FrameData[],
};

export class FrameData {
    public depth = 0;
    public sections = {} as Record<string, number[][]>;
}

const ProfilerNull = {
    getFrames() {
        return state.frames;
    },
    frameStart() {
        // fo eslint
    },
    frameEnd() {
        // fo eslint
    },
    measure(_section: string, func: Callback<any>) {
        return func();
    },
    section(_section: string) {
        return () => {
            // fo eslint
        };
    },
    reset() {

    },
};

const ProfilerImpl = {
    getFrames() {
        try {
            return state.frames;
        }
        finally {
            state.frames = [];
        }
    },
    frameStart() {
        state.current = new FrameData();
    },
    frameEnd() {
        if (state.current) {
            if (Object.keys(state.current.sections).length) {
                state.frames.push(state.current);
                if (state.frames.length > 20) {
                    state.frames.splice(0, 1);
                }
            }
            state.current = null;
        }
    },
    measure(section: string, func: Callback<any>) {
        const s = ProfilerImpl.section(section);
        try {
            return func();
        }
        finally {
            s();
        }
    },
    section(section: string) {
        if (state.current) {
            const entry = [state.current.depth++, performance.now(), 0];
            (state.current.sections[section] ?? (state.current.sections[section] = [])).push(entry);
            return () => {
                entry[2] = performance.now();
                state.current.depth--;
            };
        }
        return () => {
            // Ehehe
        };
    },
    reset() {
        state.current = null;
        state.frames = [];
    },
};

const ProfilerControls = {
    setEnabled(value: boolean) {
        if (value) Object.assign(this, ProfilerImpl);
        else Object.assign(this, ProfilerNull);
    },
};

export const Profiler = Object.assign(ProfilerControls, ProfilerImpl);

export const profileSection = (sectionName: string): MethodDecorator =>
    (target: Record<string, any>, propertyKey: string | symbol, descriptor: PropertyDescriptor) => {
        const original = descriptor.value;
        descriptor.value = function (...args: any[]) {
            const s = Profiler.section(sectionName);
            try {
                return original.apply(this, args);
            }
            finally {
                s();
            }
        };
        return descriptor;
    };

export const profileFrame = (sectionName: string, enabled = true): MethodDecorator =>
    (target: Record<string, any>, propertyKey: string | symbol, descriptor: PropertyDescriptor) => {
        const original = descriptor.value;
        if (enabled) {
            descriptor.value = function (...args: any[]) {
                Profiler.frameStart();
                const s = Profiler.section(sectionName);
                try {
                    return original.apply(this, args);
                }
                finally {
                    s();
                    Profiler.frameEnd();
                }
            };
        }
        return descriptor;
    };
